import { REACT_APP_ESIGN_WEBCOMPONENT_URL } from 'envs';

import { InjectScript } from './script';

let injection: Promise<void> | null = null;

/**
 * Load the esign.frontend bundle exactly once per page.
 *
 * That bundle registers **both** custom elements — `<simplici-sign>` and
 * `<simplici-evault>` — and `customElements.define()` throws if it runs twice for
 * the same name. Each consumer previously kept its own `isInjected` flag, so a
 * session that opened eVault and then the send-envelope modal injected the script
 * twice and the second load threw. Memoising the promise means every caller awaits
 * the same single load.
 */
export const loadEsignWebComponents = (): Promise<void> => {
	if (!injection) {
		injection = InjectScript([
			{ type: 'script', link: REACT_APP_ESIGN_WEBCOMPONENT_URL },
		]);
	}
	return injection;
};
